import React from 'react'
export default function TagGuestsButton(props) {
  return (
    <button
      type="button"
      className="small tag-guests-button"
      onClick={props.handleClick}
    >
      <i className="icon-tag" /> Tag Guests
    </button>
  );
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/tag-guests/components/tag-guests-button.es6